import { useUser } from "@/composables/user";
import { ApiClient } from "@/services/apiClient";
import { OrderStatus_Schema } from "@/services/marketplace/order/orderSchema";
import { type OrderId } from "@/services/marketplace/order/orderTypes";
import { Sale_Schema } from "@/services/marketplace/order/sales/salesSchema";
import { type Sale } from "@/services/marketplace/order/sales/salesTypes";
import { assertUserIsLoggedIn } from "@/services/user";
import { handleAxiosError } from "@/utilities";
import { z } from "zod";
import { createError404Link, router } from "@/router";

const ApiResponse_SaleList_Schema = z.object({
  orders: z.array(Sale_Schema),
  // Not implemented yet
  //totalCount: WholeNumber_Schema,
});
type ApiResponse_SaleList = z.infer<typeof ApiResponse_SaleList_Schema>;

export const fetchSaleList = async (_page: number, _perPage: number): Promise<ApiResponse_SaleList> => {
  const { user } = useUser();
  assertUserIsLoggedIn(user.value);

  const url = "api/order/order";
  const query = { sellerUserId: user.value.id };
  return ApiClient.get<ApiResponse_SaleList>(url, query).then(({ data }) => ApiResponse_SaleList_Schema.parse(data));
};

const OrderStatusCount_Schema = z.object({
  statusCounts: z.record(OrderStatus_Schema, z.number().int()),
});
export type OrderStatusCount = z.infer<typeof OrderStatusCount_Schema>;

export const fetchOrderStatusCount = async (): Promise<OrderStatusCount> => {
  const url = "api/order/order-status-count";
  return ApiClient.get<OrderStatusCount>(url).then(({ data }) => OrderStatusCount_Schema.parse(data));
};

export const fetchSale = async (id: OrderId): Promise<Sale> => {
  const url = "api/order/order/" + id;
  return ApiClient.get<Sale>(url)
    .then(({ data }) => Sale_Schema.parse(data))
    .catch(handleAxiosError({ 403: () => router.replace(createError404Link()) }));
};
